@if (isNotFound) {
<div class="container text-center">
  <h1 [innerHTML]="'Video room not found' | translate"></h1>
  @if (!isIFrame && !isAgent) {
  <p [innerHTML]="'The call was ended by the agent. Please request for a new video call.' | translate"></p>
  } @if (isIFrame || isAgent) {
  <div class="text-center">
    <p [innerHTML]="'The room was probably closed by another participant.' | translate"></p>
    <p [innerHTML]="'Create a new one by going back and clicking the camera button again.' | translate"></p>
    <a (click)="back()" avButton color="link"
      >&larr; {{ "Back" | translate }}</a
    >
  </div>
  }
</div>
} @if (isScheduleNotFound) {
<div class="container text-center">
  <h1 [innerHTML]="'Video room not found' | translate"></h1>
  <p [innerHTML]="'Please contact our team to schedule a new video call.' | translate"></p>
</div>
} @if (isParticipantLimitReached) {
<div class="container text-center">
  <h1 [innerHTML]="'Maximum participants reached' | translate"></h1>
  <p [innerHTML]="'Please notify the agent that provided the link that you cannot join.' | translate"></p>
</div>
} @if (isScheduledLater) {
<div class="container text-center">
  <h1 [innerHTML]="'Video room is not available at this time' | translate"></h1>
  <p [innerHTML]="'This call has been scheduled for a later time. You can join 5 minutes before the scheduled start time.' | translate"></p>
</div>
} @if (isNotSupported) {
<div class="container text-center">
  <h1 translate>{{ errorTitle }}</h1>
  <p translate>
    {{ error }}
  </p>
  @if (isMobileChromeRequired) {
  <div>
    <img
      class="browser-icon"
      src="assets/images/chrome-icon.svg"
      alt="Google Chrome"
    />
    <a
      class="btn"
      target="_blank"
      href="https://play.google.com/store/apps/details?id=com.android.chrome"
      >Download</a
    >
  </div>
  } @if (isMobileSafariRequired) {
  <div>
    <img
      class="browser-icon"
      src="assets/images/safari-icon.svg"
      alt="Apple Safari"
    />
  </div>
  } @if (isDesktopChromeRequired) {
  <div>
    <img
      class="browser-icon"
      src="assets/images/chrome-icon.svg"
      alt="Google Chrome"
    />
    <a class="btn" target="_blank" href="https://www.google.com/chrome/"
      >Download</a
    >
  </div>
  }
</div>
} @if (isSessionExpired) {
<div class="container text-center">
  <h1 [innerHTML]="'Session Expired' | translate"></h1>
  <p [innerHTML]="'Please request a new link from the available agent.' | translate"></p>
  @if (isAppointmentTokenExpired) {
  <div class="text-muted">
    <p [innerHTML]="'You are getting this message because this is not your first time accessing this link.' | translate"></p>
    <p [innerHTML]="'If the first time you could not join our call, most probably the meeting was cancelled and our notification hasn\'t reached you yet. We are sorry for any inconvenience created.' | translate"></p>
  </div>
  }
</div>
} @if (isAccessDenied) {
<div class="container text-center">
  <h1 [innerHTML]="'Access Denied' | translate"></h1>
  <p [innerHTML]="'Oups! You shouldn\'t be here.' | translate"></p>
</div>
} @if (isPageNotFound) {
<div class="container text-center">
  <h2>{{ pageNotFoundMessage }}</h2>
</div>
} @if (isIFrame && isCookiesDisabledError) {
<div class="container text-center">
  <h1 [innerHTML]="'Cookies Disabled' | translate"></h1>
  <p [innerHTML]="'Please enable third party cookies and try again.' | translate"></p>
</div>
} @if (!isIFrame && isCookiesDisabledError) {
<div class="container text-center">
  <h1 [innerHTML]="'Cookies Disabled' | translate"></h1>
  <p [innerHTML]="'Please enable cookies and try again.' | translate"></p>
</div>
} @if (isPurecloudInitError) {
<div class="container text-center">
  <p [innerHTML]="'Could not initialize application.' | translate"></p>
</div>
} @if (isGenericError) {
<div class="container text-center">
  <h1 [innerHTML]="'Oups! Something unexpected happened' | translate"></h1>
  <p>{{ error | translate }}</p>
</div>
} @if (isAuthenticationError) {
<div class="container text-center">
  <h1 [innerHTML]="'Authentication failed' | translate"></h1>
  <p translate>{{ error }}</p>
</div>
} @if (isRTCConnectionError) {
<div class="container text-center">
  @if (isMobileSafari26) {
  <h1 [innerHTML]="'Connection failed' | translate"></h1>
  <p [innerHTML]="'Safari 26 isn\'t currently supported. Please switch to a supported browser like Chrome or Firefox.' | translate"></p>
  } @if (!isMobileSafari26) {
  <h1 [innerHTML]="'Connection to RTC failed' | translate"></h1>
  <p [innerHTML]="'Please make sure you have opened all the required ports and that the service is up and running' | translate"></p>
  }
</div>
} @if (isAppointmentCompleted) {
<div class="container text-center">
  <h1 [innerHTML]="'Appointment has been completed' | translate"></h1>
  <p [innerHTML]="'Please request a new appointment' | translate"></p>
</div>
} @if (isAppointmentExpired) {
<div class="container text-center">
  <h1 [innerHTML]="'Appointment has expired' | translate"></h1>
  <p [innerHTML]="'Please request a new appointment' | translate"></p>
</div>
} @if (isAppointmentError) {
<div class="container text-center">
  <h1 [innerHTML]="'We were unable to start your appointment at this time.' | translate"></h1>
  <p class="text-muted" translate>
    {{ error }}
  </p>
</div>
} @if (isAppointmentRevoked) {
<div class="container text-center">
  <h1 [innerHTML]="'Invalid link' | translate"></h1>
  <p [innerHTML]="'This link is no longer valid. If you believe this is an error, please contact the issuer of the link or the relevant support team.' | translate"></p>
</div>
} @if (isLicenseRequired) {
<div class="container text-center">
  <h1 [innerHTML]="'License required' | translate"></h1>
  <p [innerHTML]="'You don\'t have the proper license to access this page' | translate"></p>
  <p translate class="text-center">
    <a (click)="back()" avButton color="link"
      >&larr; {{ "Back" | translate }}</a
    >
  </p>
</div>
} @if (isAppointmentNotFound) {
<div class="container text-center">
  <h1 [innerHTML]="'Appointment not found' | translate"></h1>
  <p [innerHTML]="'Please request a new appointment' | translate"></p>
</div>
} @if (isConversationFailed) {
<div class="container text-center">
  <h1 [innerHTML]="'Could not estabish a connection' | translate"></h1>
  <p [innerHTML]="'Please follow the appointment link to try again' | translate"></p>
</div>
} @if (isTicketNotFound) {
<div class="container text-center">
  <h1 [innerHTML]="'Ticket has expired or is invalid' | translate"></h1>
  <p [innerHTML]="'Please request a new one' | translate"></p>
</div>
} @if (isAppointmentCancelled) {
<div class="container text-center">
  <h1 [innerHTML]="'This appointment has been cancelled' | translate"></h1>
</div>
} @if (isAppointmentManageDenied) {
<div class="container text-center">
  <h1 [innerHTML]="'This appointment can no longer be changed' | translate"></h1>
  <p [innerHTML]="'The appointment may have been updated or the link may no longer be valid. Please use the latest appointment notification link or contact us again.' | translate"></p>
</div>
} @if (!!redirectUrl) {
<div class="copy-container">
  <h2 class="copy-container-title" [innerHTML]="'Room Link' | translate"></h2>
  <div class="textarea-wrapper">
    <div class="textarea-container">
      <textarea rows="2" disabled>{{ redirectUrl }}</textarea>
    </div>
    <div>
      <button avButton color="accent" (click)="copy()" translate>
        Copy to clipboard
      </button>
    </div>
  </div>
</div>
}

@if (imageUrl()) {
<img
  class="error-image"
  [src]="imageUrl()"
  alt=""
  (error)="imageFailed.set(true)"
/>
}

<!-- <av-card
        class="appointment"
        *ngIf="isAppointmentAvailable()"
        [backdrop]="false"
        >
        <av-card-header>
          {{ "Appointment" | translate }}
        </av-card-header>
        <av-card-body [no-header]>
          <div class="fx-row fx-gap fx-align-center">
            <h3 class="no-margin">
              {{
              appointment().start
              | dayjsFormat : "dddd DD MMMM, HH:mm" : lang
              }}
            </h3>
            <span class="text-muted">{{ timezoneOffset() }}</span>
          </div>
        </av-card-body>
      </av-card> -->
